import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { loadEnvironment } from '@schir-int-client/environment';
import moment from 'moment';
import 'moment/locale/de';

loadEnvironment(environment.environmentUrl).then(env => {
	if (env.production) {
		enableProdMode();
	}

	// Überschreibe moment.defineLocale, um das deutsche Datumsformat einzufrieren und nachträgliche Änderungen durch Angular Material zu verhindern
	const originalDefineLocale = moment.defineLocale;
	moment.defineLocale = function (name: string, config: any) {
		const result = originalDefineLocale.call(this, name, config);
		if (name === 'de' && result._longDateFormat) {
			Object.freeze(result._longDateFormat);
		}
		return result;
	};

	moment.locale('de');

	function bootstrap() {
		platformBrowser()
			.bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
			.catch(err => console.log(err));
	}

	bootstrap();
});
